import * as localforage from "localforage";
import axios from "axios";

export const getFirmwareListAPI = async (filterCondition, deviceId) => {
  const companyId = await localforage.getItem("companyId");
  const deviceData = await localforage.getItem(deviceId);
  const deviceModelId = deviceData ? deviceData.device_model_id : undefined;
  let response = await axios({
    url: `/api/v2/command/firmwares`,
    method: "GET",
    params: {
      filter_condition: filterCondition,
      company_id: companyId,
      device_model_id: deviceModelId
    }
  });
  if (response.data && response.data.firmwares) {
    return response.data.firmwares;
  }
};
